import Vue from 'vue';
import App from './App.vue';
// You can change this import to `import router from './starterRouter'` to quickly start development from a blank layout.
import router from './router';
import NowUiKit from './plugins/now-ui-kit';
import Vuex from 'vuex'
import VueScrollTo from 'vue-scrollto';

Vue.use(VueScrollTo);


import 'es6-promise/auto'
import store from './store'

Vue.config.productionTip = false;

Vue.use(NowUiKit);
Vue.use(Vuex);
new Vue({
    el:'#app',
    store,
    router,
    render: h => h(App)
});
